export const isUAHost = () => document.location.host === 'register.ukrajinskyziak.sk'